/* El Laguito — lifts the white studio background off product pictures so they sit on the dark page.
   2026-11-03 (Zein: "a black area on the lighter that wasn't there before"): the lift used to treat any pixel
   lighter than 236 as background, so where a bright surface (mother-of-pearl, white lacquer) touched the edge
   of a close-up, the lift ran into the product and left a black patch. Now the background colour is measured
   from the picture's border and only pixels within 10 of that colour — and nearly colourless — are lifted.
   Alt text containing [nolift] skips a picture. Not loaded for Floris London (pictures stay on white). */
(function () {
  "use strict";
  if (window.__elcWhiteBg) return;
  window.__elcWhiteBg = true;
  var MAX = 1400, WHITE = 236, FEATHER = 196, NOLIFT = "[nolift]", TOL = 10, SAT = 10, FLOOR = 226;
  function isWhite(d, i) { return d[i] >= WHITE && d[i + 1] >= WHITE && d[i + 2] >= WHITE && d[i + 3] > 0; }
  function median(arr) { if (!arr.length) return 255; arr.sort(function (a, b) { return a - b; }); return arr[arr.length >> 1]; }
  function lift(img) {
    if (!img || img.getAttribute("data-elc-bg")) return;
    if ((img.getAttribute("alt") || "").toLowerCase().indexOf(NOLIFT) > -1) { img.setAttribute("data-elc-bg", "skip"); return; }
    img.setAttribute("data-elc-bg", "wait");
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf("data:") === 0 || src.indexOf("blob:") === 0) { img.setAttribute("data-elc-bg", "skip"); return; }
    if (/[?&]width=\d+/.test(src)) src = src.replace(/([?&])width=\d+/, "$1width=" + MAX);
    var probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight;
        if (!w || !h) { img.setAttribute("data-elc-bg", "skip"); return; }
        var s = Math.min(1, MAX / Math.max(w, h)), cw = Math.round(w * s), ch = Math.round(h * s);
        var c = document.createElement("canvas"); c.width = cw; c.height = ch;
        var ctx = c.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, cw, ch);
        var im = ctx.getImageData(0, 0, cw, ch), d = im.data;
        /* 1. is the border mostly white? (same test as before) — and what exactly is the background colour? */
        var bw = 0, bt = 0, br = [], bgc = [], bb = [];
        var sample = function (p) { bt++; var j = p * 4; if (isWhite(d, j)) { bw++; br.push(d[j]); bgc.push(d[j + 1]); bb.push(d[j + 2]); } };
        for (var bx = 0; bx < cw; bx += 2) { sample(bx); sample((ch - 1) * cw + bx); }
        for (var by = 0; by < ch; by += 2) { sample(by * cw); sample(by * cw + cw - 1); }
        if (bw < bt * 0.6) { img.setAttribute("data-elc-bg", "skip"); return; }
        var lr = Math.max(FLOOR, median(br) - TOL), lg = Math.max(FLOOR, median(bgc) - TOL), lb = Math.max(FLOOR, median(bb) - TOL);
        /* 2. background pixel = close to the measured background colour and nearly colourless */
        var isBg = function (j) {
          var r = d[j], g = d[j + 1], b = d[j + 2];
          if (d[j + 3] === 0 || r < lr || g < lg || b < lb) return false;
          var mx = r > g ? (r > b ? r : b) : (g > b ? g : b), mn = r < g ? (r < b ? r : b) : (g < b ? g : b);
          return mx - mn <= SAT;
        };
        /* 3. flood from the edges */
        var n = cw * ch, mask = new Uint8Array(n), stack = [];
        for (var x = 0; x < cw; x++) { stack.push(x); stack.push((ch - 1) * cw + x); }
        for (var y = 0; y < ch; y++) { stack.push(y * cw); stack.push(y * cw + cw - 1); }
        while (stack.length) {
          var p = stack.pop();
          if (mask[p] || !isBg(p * 4)) continue;
          mask[p] = 1;
          var px = p % cw;
          if (px > 0) stack.push(p - 1);
          if (px < cw - 1) stack.push(p + 1);
          if (p >= cw) stack.push(p - cw);
          if (p < n - cw) stack.push(p + cw);
        }
        var filled = 0;
        for (var i = 0; i < n; i++) if (mask[i]) { d[i * 4 + 3] = 0; filled++; }
        if (filled < n * 0.02) { img.setAttribute("data-elc-bg", "skip"); return; }
        /* 4. soften the edge one pixel in */
        for (var q = 0; q < n; q++) {
          if (mask[q]) continue;
          var qx = q % cw;
          var near = (qx > 0 && mask[q - 1]) || (qx < cw - 1 && mask[q + 1]) || (q >= cw && mask[q - cw]) || (q < n - cw && mask[q + cw]);
          if (!near) continue;
          var j = q * 4, mx = Math.max(d[j], d[j + 1], d[j + 2]);
          if (mx > FEATHER) d[j + 3] = Math.round(d[j + 3] * (255 - mx) / (255 - FEATHER));
        }
        ctx.putImageData(im, 0, 0);
        c.toBlob(function (blob) {
          if (!blob) { img.setAttribute("data-elc-bg", "skip"); return; }
          var url = URL.createObjectURL(blob);
          img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = url;
          img.setAttribute("data-elc-bg", "done");
        }, "image/png");
      } catch (e) { img.setAttribute("data-elc-bg", "skip"); }
    };
    probe.onerror = function () { img.setAttribute("data-elc-bg", "skip"); };
    probe.src = src;
  }
  function run() {
    var sel = ".product__media-item img, .product__media img, .thumbnail img", imgs = document.querySelectorAll(sel);
    for (var i = 0; i < imgs.length; i++) (function (img) {
      if (img.complete && img.naturalWidth) lift(img); else img.addEventListener("load", function () { lift(img); }, { once: true });
    })(imgs[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
  document.addEventListener("shopify:section:load", run);
  var mo = new MutationObserver(function () { run(); });
  var gal = document.querySelector("media-gallery") || document.querySelector(".product__media-wrapper");
  if (gal) mo.observe(gal, { childList: true, subtree: true });
})();
